<template>
  <div>
    <header class="g-header-container">
      <c-header title="真题解析" />
    </header>
    <main class="g-view-container">
      <div v-if="list.length" class="container">
        <question :data="list[currentIndex]" />
        <answer :data="list[currentIndex]" />
      </div>
      <van-empty v-else description="暂无数据" />
    </main>
    <footer class="g-footer-container">
      <div v-if="list.length" class="menu">
        <button :disabled="isFirst" @click="currentIndex -= 1">
          &lt; 上一题
        </button>
        <span>{{ currentIndex + 1 }}/{{ list.length }}</span>
        <button :disabled="isLast" @click="currentIndex += 1">
          下一题 &gt;
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
  import CHeader from 'components/header';
  import question from './question';
  import answer from './answer';

  export default {
    name: 'analysis',
    data() {
      return {
        sectionId: this.$route.params.sectionId,
        currentIndex: 0,
        list: [],
      };
    },
    computed: {
      isFirst() {
        return this.currentIndex === 0;
      },
      isLast() {
        return this.currentIndex === this.list.length - 1;
      },
    },
    components: {
      CHeader,
      question,
      answer,
    },
    created() {
      this.axios
        .get(
          `https://api.zhuokao360.com/question/list?sectionId=${this.sectionId}`,
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.data;
          }
        });
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.container {
  margin: 10px 15px;
  padding: 10px 15px;
  background-color: #fff;
  border-radius: 10px;
}

.question-type {
  font-size: 15px;
  color: $theme-color;
  line-height: 21px;
}

.qustion-title {
  margin-top: 5px;
  font-size: 16px;
  color: #707070;
  line-height: 24px;
}

.qustion-options > li {
  font-size: 14px;
  color: #666;
  line-height: 40px;
}

.answer-type {
  font-size: 12px;
  color: $theme-color;
  line-height: 26px;
}

.answer-detail {
  font-size: 14px;
  color: #666;
  line-height: 21px;
}

.menu {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 50px;
  font-size: 15px;
  color: #333;
  background-color: #fff;
}

button {
  background-color: #fff;
}

.menu button:disabled {
  color: #ccc;
}
</style>
